import { CheckoutState } from '../../state';
import { getQuestionsForAttendees } from './attendees';
import { getQuestionsForBasicInfo } from './basicInfo';
import { getQuestionsForBuyer } from './buyer';

export const getSurvey = (state: CheckoutState) => ({
    questionsForAttendees: getQuestionsForAttendees(state),
    questionsForBuyer: getQuestionsForBuyer(state),
    questionsForBasicInfo: getQuestionsForBasicInfo(state),
});
